var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.949,
    height: 49.919,
    viewBox: "0 0 49.949 49.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-decline",
    transform: "translate(-4 -4.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19128",
    "data-name": "Trazado 19128",
    d: "M39.106,22.989l-2.714-2.714-6.814,6.814-6.814-6.814L20.05,22.989l2.714,2.733,4.1,4.081L20.05,36.617l2.714,2.714L25.5,36.617l4.081-4.1,6.814,6.814,2.714-2.714L32.292,29.8Z",
    transform: "translate(14.844 14.83)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19129",
    "data-name": "Trazado 19129",
    d: "M30.948,48.482a1.931,1.931,0,0,0-1.925-1.925H7.85v-23.1a3.861,3.861,0,0,1,3.85-3.85h1.925v3.869a1.925,1.925,0,1,0,3.85,0v-3.85H29.023v3.85a1.925,1.925,0,1,0,3.85,0v-3.85h5.775v9.624a1.925,1.925,0,0,0,3.85,0V15.779H32.873v-1.5a9.907,9.907,0,0,0-8.681-9.99,9.618,9.618,0,0,0-10.567,9.586v1.906H11.7a7.7,7.7,0,0,0-7.7,7.7V50.427H29.023A1.931,1.931,0,0,0,30.948,48.5ZM17.474,13.835a5.775,5.775,0,0,1,11.549,0v1.906H17.474Z",
    fill: "#00c1d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingDecline);
export default __webpack_public_path__ + "static/media/shopping-decline.9ebf80f7cc567d47600cc33944242a23.svg";
export { ForwardRef as ReactComponent };